const packageStatuses = {
  0: 'bought',
  1: 'processed',
  2: 'in_transit',
  3: 'on_delivery',
  4: 'received',
  5: 'delivered'
}
const deliveryTypes = {
  0: 'homeDelivery',
  1: 'storePickup',
  2: 'clickAndCollect'
}
const packageHistories = [
  { packageStatus: packageStatuses[0], date: '31-08-2025, 7:00:00 p. m.' },
  { packageStatus: packageStatuses[1], date: '01-09-2025, 8:00:00 a. m.' },
  { packageStatus: packageStatuses[2], date: '01-09-2025, 6:00:00 p. m.' },
  { packageStatus: packageStatuses[3], date: '03-09-2025, 3:00:00 p. m.' },
  { packageStatus: packageStatuses[4], date: '04-09-2025, 6:00:00 p. m.' },
  { packageStatus: packageStatuses[5], date: '04-09-2025, 8:00:00 p. m.' }
]

const createCourierData = () => ({
  id: 0,
  name: 'blueexpress',
  sla: 97,
  displayName: 'Blue Express'
})

const createLocationData = () => ({
  state: 'Metropolitana de Santiago',
  stateId: 13,
  city: 'Santiago',
  cityId: 131001
})

const createProductData = () => ({
  products: [{
    productName: 'Test Product Name',
    price: 99990,
    discount: 0,
    quantity: 2,
    photoUrl: [
      { URLIMAGEN: 'TestImageUrl' }
    ]
  }],
  paidCost: 99990,
  totalProductsPrice: 299970
})

const createClientData = () => ({
  deliveryAddress: 'Calle Principal 123',
  clientEmail: 'cliente.ejemplo@mail.com',
  clientName: 'Juan',
  clientLastName: 'Perez',
  clientPhone: '+56912345678',
  verification: [
    {
      nombre: 'Juan Perez',
      rut: '12345678-9'
    }
  ]
})

const createPackageData = (status: number) => ({
  packageId: 'TestPackageId',
  pinflagId: 'TestPinflagId',
  saleOrder: 'TestSaleOrder',
  orderId: 'TestSaleOrder',
  packageStatus: packageStatuses[status as keyof typeof packageStatuses],
  packageHistory: packageHistories.slice(0, status + 1),
  trackingNumber: 'TEST-4567890'
})

export const PREVIEW_VALUES = (
  companyName: string,
  companyId: number,
  status: number,
  delivery: number
) => ({
  courier: createCourierData(),
  clickAndCollect: delivery !== 0,
  deliveryType: deliveryTypes[delivery as keyof typeof deliveryTypes],
  ...createLocationData(),
  purchaseDate: '2025-09-01T00:00:00.000Z',
  companyName,
  companyId,
  holdingId: 0,
  ...createProductData(),
  ...createPackageData(status),
  evidencePhotos: {
    courier: []
  },
  warehouseName: 'Tienda Principal',
  warehouseId: -1,
  ...createClientData(),
  promisedDeliveryDate: Date.now() + 7 * 24 * 60 * 60 * 1000,
  shippingCost: 2990,
  totalPickupDays: 7,
  managedByPinflag: true
})

export const PREVIEW_TOTAL_PRODUCTS = {
  products: [
      {
          productName: 'Lapiz',
          price: 1200,
          quantity: 1,
          photoUrl: [],
          discount: 0
      },
      {
          productName: 'Cuaderno',
          price: 2000,
          quantity: 1,
          photoUrl: [],
          discount: 0
      }
  ],
  totalProductsPrice: 3200,
  paidCost: 12000
}

export const PREVIEW_SCHEDULE = {
  id: 0,
  name: 'Tienda Principal de Prueba',
  schedules: [
      {
          day: 'thursday',
          startTime: '09:00:00',
          finishTime: '19:00:00',
          open: true
      },
      {
          day: 'friday',
          startTime: '09:00:00',
          finishTime: '19:00:00',
          open: true
      },
      {
          day: 'monday',
          startTime: '09:00:00',
          finishTime: '19:00:00',
          open: true
      },
      {
          day: 'saturday',
          startTime: '10:00:00',
          finishTime: '13:00:00',
          open: true
      },
      {
          day: 'tuesday',
          startTime: '09:00:00',
          finishTime: '19:00:00',
          open: true
      },
      {
          day: 'wednesday',
          startTime: '09:00:00',
          finishTime: '19:00:00',
          open: true
      }
  ]
}
